module.exports = __webpack_public_path__ + "img/0x5D9ab5522c64E1F6ef5e3627ECCc093f56167818.237ffb83.png";